module.exports = __webpack_public_path__ + "img/qb_05.f13ef99f.png";